<template>
  <div>
    <div class="flex items-center">
      <div class="flex-1 min-w-0 pr-2 md:pr-3">
        <input type="text" name="ref-link" id="ref-link" ref="refLink"
               class="block w-full text-sm border-gray-300 rounded focus:border-gray-400 focus:ring-0"
               :value="href">
      </div>
      <div @click="copyRefLink">
          <tooltip :content="tooltipText || 'Copied'" class="-mt-0.5" method="click">
              <btn :type="btnType">
                <span class="hidden md:block -mx-1">{{ btnText || 'Copy URL' }}</span>
                <span class="md:hidden">
                <svg class="w-5 h-5 p-px -ml-2 -mr-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.007-1H7zM5.003 8L5 20h10V8H5.003zM9 6h8v10h2V4H9v2z"/></svg>
                </span>
              </btn>
          </tooltip>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    href: {
      type: String,
    },
    btnType: {
        type: String,
        default: 'light'
    },
    btnText: {
        type: String
    },
    tooltipText: {
        type: String
    }
  },
  data() {
    return {}
  },
  methods: {
    copyRefLink() {
      const el = document.createElement('textarea');
      el.value = this.$refs.refLink.value;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  }
}
</script>
